"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _appRoutes = _interopRequireDefault(require("./app-routes"));

var _appUrlsUtils = require("./app-urls-utils");

const resolver = ({
  prefix,
  host,
  includeHost = false
}) => {
  const getUrl = url => (0, _appUrlsUtils.getAppUrl)({
    url,
    host,
    prefix,
    includeHost
  });

  const getFullUrl = url => (0, _appUrlsUtils.getAppFullUrl)({
    url,
    host,
    prefix
  });

  const getHostUrl = url => (0, _appUrlsUtils.getAppHostUrl)({
    url,
    host
  });

  return {
    AUTH: getUrl(_appRoutes.default.AUTH),
    AUTH2: getUrl(_appRoutes.default.AUTH2),
    WELCOME: getUrl(_appRoutes.default.WELCOME),
    WELCOME_ADMIN: getUrl(_appRoutes.default.WELCOME_ADMIN),
    DASHBOARD: getUrl(_appRoutes.default.DASHBOARD),
    CREATE_COLLECTION: getUrl(_appRoutes.default.CREATE_COLLECTION),
    PRODUCT: getUrl(_appRoutes.default.PRODUCT),
    TEMPLATE: getUrl(_appRoutes.default.TEMPLATE),
    CREATE: templateId => getUrl("".concat(_appRoutes.default.CREATE, "/").concat(templateId)),
    EDIT: videoId => getUrl("".concat(_appRoutes.default.EDIT, "/").concat(videoId)),
    PUBLISH: (videoId, renderingDuration = 0) => getUrl("".concat(_appRoutes.default.PUBLISH, "/").concat(videoId, "/").concat(renderingDuration)),
    PRIVACY_POLICY: getUrl(_appRoutes.default.PRIVACY_POLICY),
    EMBEDDED_VIDEO: videoId => getUrl("".concat(_appRoutes.default.EMBEDDED_VIDEO, "/").concat(videoId)),
    ADMIN: templateId => getUrl("".concat(_appRoutes.default.ADMIN, "/").concat(templateId)),
    IMAGE: getUrl(_appRoutes.default.IMAGE),
    PRICING: getUrl(_appRoutes.default.PRICING),
    BILLING: getUrl(_appRoutes.default.BILLING),
    FAQ: getFullUrl(_appRoutes.default.FAQ),
    BLOG: getHostUrl(_appRoutes.default.BLOG)
  };
};

var _default = resolver;
exports.default = _default;